import { render, staticRenderFns } from "./manage-fees.vue?vue&type=template&id=70218880&scoped=true"
import script from "./manage-fees.vue?vue&type=script&lang=js"
export * from "./manage-fees.vue?vue&type=script&lang=js"
import style0 from "./manage-fees.vue?vue&type=style&index=0&id=70218880&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70218880",
  null
  
)

export default component.exports